<br />
<div class="list-group">
  <!-- START list title-->
  <div class="list-group-item border-0">
    <h6>
      Current Default DNA
    </h6>
  </div>

  <div class="list-group-item list-group-item-action border-0">
    <div class="form-group row">
      <div class="col-md-12">
        <img *ngIf="base64LogoImage" [src]="base64LogoImage" height="40px" />
      </div>
    </div>
  </div>

  <!-- END list title-->
  <div class="list-group-item list-group-item-action border-0">
    <div class="media" *ngIf="!defaultDna">
      <div class="media-body text-truncate">
        <strong class="text-danger">Please assign a default DNA</strong>
      </div>
      <div class="ml-auto">
        <span class="circle bg-danger circle-lg"></span>
      </div>
    </div>
    <div class="media" *ngIf="defaultDna">
      <div class="media-body text-truncate">
        <strong>{{defaultDna.dnaName}} {{defaultDna.currentVersion ? 'V' + defaultDna.currentVersion : ''}}</strong>
        - <label class="text-muted">{{defaultDna.clientName}}</label>
      </div>
      <div class="ml-auto">
        <span class="circle bg-success circle-lg"></span>
      </div>
    </div>
    <div class="form-group">
      <div class="form-group row" *ngIf="defaultDna && defaultDna.colour1">
        <div class="col-md-4">
          <strong>Colour 1</strong>
        </div>
        <div class="col-md-3 rounded text-align-left" [style.background-color]="defaultDna.colour1">
        </div>
        <div class="col-md-5"></div>
      </div>

      <div class="form-group row" *ngIf="defaultDna && defaultDna.colour2">
        <div class="col-md-4">
          <strong>Colour 2</strong>
        </div>
        <div class="col-md-3 rounded text-align-left" [style.background-color]="defaultDna.colour2">
        </div>
        <div class="col-md-5"></div>
      </div>

      <div class="form-group row" *ngIf="defaultDna && defaultDna.colour3">
        <div class="col-md-4">
          <strong>Colour 3</strong>
        </div>
        <div class="col-md-3 rounded text-align-left" [style.background-color]="defaultDna.colour3">
        </div>
        <div class="col-md-5"></div>
      </div>

      <div class="form-group row" *ngIf="defaultDna && defaultDna.colour4">
        <div class="col-md-4">
          <strong>Colour 4</strong>
        </div>
        <div class="col-md-3 rounded text-align-left" [style.background-color]="defaultDna.colour4">
        </div>
        <div class="col-md-5"></div>
      </div>

      <div class="form-group row" *ngIf="defaultDna && defaultDna.colour5">
        <div class="col-md-4">
          <strong>Colour 5</strong>
        </div>
        <div class="col-md-3 rounded text-align-left" [style.background-color]="defaultDna.colour5">
        </div>
        <div class="col-md-5"></div>
      </div>
      <br />
      <div class="form-group row" *ngIf="defaultDna">
        <div class="col-md-5">
          <a class="btn btn-green btn-sm" style="color:white" title="Edit DNA Settings" (click)="onDnaSettingsClick()">
            <strong>DNA Settings</strong>
          </a>
        </div>
        <div class="col-md-5 text-align-left">
          <a class="btn btn-warning btn-sm" style="color:white" title="DNA Manager" (click)="onDnaConfigurationClick()">
            <strong>DNA Configuration</strong>
          </a>
        </div>
      </div>
    </div>

    <div>
      <hr />
    </div>
    <br />

    <!-- START list title-->
    <h6>
      Set a New Default DNA
    </h6>
    <!-- END list title-->
    <div class="list-group-item list-group-item-action border-0">
      <app-dnaselector (defaultDnaChanged)="defaultDnaChanged($event)"></app-dnaselector>
    </div>
    <div class="list-group-item list-group-item-action border-0">
      <div class="media">
        <div class="form-group">
          <!-- Optional link to list more users-->
          <a class="btn btn-green btn-sm" style="color: white" title="Set selected DNA as default" (click)="setDnaAsDefaultEvent($event)">
            <strong>Set as Default</strong>
          </a>
        </div>
      </div>
    </div>
    <hr />
  </div>
</div>
